import axios from "axios"
import { ServiceConfig } from "./service-constants"

const axiosOptions= {
    baseURL: ServiceConfig.baseUrl,
}

export const axiosInstance = axios.create(axiosOptions);